import {Box, Card, CardProps, Group, Title} from "@mantine/core";
import React from "react";

interface CardPadraoProps extends CardProps {
  titulo?: string;
  botao?: React.ReactElement;
}

export default function CardPadrao(props: CardPadraoProps) {
  return (
    <Card withBorder shadow={"sm"} radius={"md"} p={"md"}{...props}>
      {props.titulo ? <Card.Section inheritPadding withBorder py={"xs"} mb={"md"}>
          <Group>
            <Title order={5} fw={500}>{props.titulo}</Title>
            <Box ml={10}>{props.botao}</Box>
          </Group>
        </Card.Section>
        : ""}
      <Card.Section p={"md"}> {props.children} </Card.Section>
    </Card>
  )
}